const spacing = factor => `${0.5 * factor}rem`;

export default spacing;
